import apiSlice from "./apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		register: builder.mutation({
			query: (credentials) => ({
				url: "/api/register",
				method: "POST",
				body: { ...credentials },
			}),
		}),
		login: builder.mutation({
			query: (credentials) => ({
				url: "/api/login",
				method: "POST",
				body: { ...credentials },
			}),
		}),
		logout: builder.mutation({
			query: () => ({
				url: "/api/logout",
				method: "POST",
			}),
		}),
		forgotPassword: builder.mutation({
			query: (credentials) => ({
				url: "/api/forgot-password",
				method: "POST",
				body: { ...credentials },
			}),
		}),
		resetPassword: builder.mutation({
			query: ({ token, data }) => ({
				url: `/api/reset-password/${token}`,
				method: "POST",
				body: { ...data },
			}),
		}),
		getCurrentUser: builder.query({
			query: () => `/api/user`,
			providesTags: (result) => {
				const id = result?.id;
				return [
					{ type: "Users", id: "LIST" },
					{ type: "Users", id },
				];
			},
		}),
		activateUser: builder.mutation({
			query: ({ token, type }) => ({
				url: `/api/${type}-accept/${token}`,
				method: "GET",
			}),
		}),
		confirmEmail: builder.mutation({
			query: ({ token }) => ({
				url: `/api/email-update-confirm/${token}`,
				method: "GET",
			}),
		}),
		loginViaToken: builder.mutation({
			query: ({ token }) => ({
				url: "/api/confirm-token",
				method: "POST",
				body: { token },
			}),
		}),
		loginAsUser: builder.mutation({
			query: ({ id, token, name }) => ({
				url: `api/users/login-as-user/${id}/${token}/${name}`,
				method: "POST",
			}),
		}),
		activateSubscription: builder.mutation({
			query: () => ({
				url: "/api/activate-subscription",
				method: "PUT",
			}),
			invalidatesTags: ["Users"],
		}),
	}),
	overrideExisting: true,
});

export const {
	useRegisterMutation,
	useLoginMutation,
	useLogoutMutation,
	useForgotPasswordMutation,
	useResetPasswordMutation,
	useGetCurrentUserQuery,
	useActivateUserMutation,
	useConfirmEmailMutation,
	useLoginViaTokenMutation,
	useLoginAsUserMutation,
	useActivateSubscriptionMutation,
} = authApiSlice;
